import { globalStoreCreator } from './store-creator'

interface ISpot {
  like_count: number
  comment_count: number
  is_favorite: boolean
}
export const { useState: useSpotState, partialUpdateState: partialUpdateSpot } =
  globalStoreCreator<ISpot>()
